import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, field, StringDecoder } from '@common/encoding';
import { v4 as uuidv4 } from 'uuid';
export class Category extends AutoEncoder {
    id;
    name = '';
    description = '';
    enabled = true;
    productIds = [];
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], Category.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Category.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], Category.prototype, "description", void 0);
__decorate([
    field({ decoder: BooleanDecoder })
], Category.prototype, "enabled", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder) })
], Category.prototype, "productIds", void 0);
//# sourceMappingURL=Category.js.map